(() => {
  if (window.alCanyonSectionsReady) return;
  window.alCanyonSectionsReady = true;
  const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const updateRail = rail => {
    const controls = document.querySelectorAll('[data-canyon-scroll]');
    controls.forEach(button => {
      if (button.getAttribute('aria-controls') !== rail.id) return;
      button.disabled = Number(button.dataset.canyonScroll) < 0
        ? rail.scrollLeft < 2
        : rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    });
  };
  const selectTab = tab => {
    const root = tab.closest('[data-canyon-tabs]');
    root.querySelectorAll('[data-canyon-tab]').forEach(item => {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
    });
    root.querySelectorAll('[data-canyon-panel]').forEach(panel => {
      panel.hidden = panel.id !== tab.getAttribute('aria-controls');
    });
    const link = root.querySelector('[data-canyon-collection-link]');
    link.href = tab.dataset.collectionUrl;
    const rail = root.querySelector('[data-canyon-panel]:not([hidden]) [data-canyon-rail]');
    if (rail) updateRail(rail);
  };
  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-canyon-tab]');
    if (tab) selectTab(tab);
    const button = event.target.closest('[data-canyon-scroll]');
    if (!button) return;
    const rail = document.getElementById(button.getAttribute('aria-controls'));
    if (rail) rail.scrollBy({left: Number(button.dataset.canyonScroll) * rail.clientWidth, behavior: reducedMotion() ? 'instant' : 'smooth'});
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-canyon-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[data-canyon-tab]')];
    const index = tabs.indexOf(tab);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    event.preventDefault(); selectTab(tabs[next]); tabs[next].focus();
  });
  const start = () => {
    document.querySelectorAll('[data-canyon-rail]').forEach(rail => {
      if (!rail.dataset.canyonBound) {
        rail.addEventListener('scroll', () => updateRail(rail), {passive: true});
        rail.dataset.canyonBound = 'true';
      }
      updateRail(rail);
    });

  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
  document.addEventListener('shopify:section:load', start);
  window.addEventListener('resize', () => document.querySelectorAll('[data-canyon-rail]').forEach(updateRail));
})();
